module.exports = __webpack_public_path__ + "media/images/emblems/Boncourt-c3027881beac5dd6b7e5b6e122de869f.png";